module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/BypCv5/CoverDesign.jpg?1685327669173",
      "alt": "This image is the cover for the book Kissing Lessons, Before… and After"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Kissing Lessons, Before… and After\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_c('b', [_c('i', [_vm._v("A Before… and After Story")])])]), _c('p', [_vm._v("A kiss is just a kiss. It doesn’t have to mean anything. Does it?")]), _vm._v(" "), _c('p', [_vm._v("At seventeen, Merry’s never been kissed. Since he doesn’t want to disappoint his prom date, he asks his more experienced best friend, Boone, for some pointers. Surprisingly, Boone agrees to give him a hands-on lesson.")]), _vm._v(" "), _c('p', [_vm._v("But they have no idea what they’re getting into.")]), _vm._v(" "), _c('p', [_vm._v("They explore hundreds of ways to make out, but somehow it isn’t enough. A week later, they’re back together for another session. This time things go further than either of them planned, and their relationship becomes awkward and uncomfortable.")]), _vm._v(" "), _c('p', [_vm._v("Have they learned enough to salvage their friendship "), _c('em', [_vm._v("and")]), _vm._v(" help it evolve? Their lessons have come to an end. They can either part ways forever… or share a true love’s kiss.")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Susan Laine\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Dreamspinner Press\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0